var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_vm.card.status === 9 && _vm.card.point == _vm.card.threshold ? _c('div', {
    staticClass: "reward-status-notification"
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('reward_card_apply_title'))
    }
  })])], 1) : [_vm.showStatusNotification ? _c('div', {
    staticClass: "reward-status-notification"
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('div', {
    staticClass: "text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.showStatusNotification)
    }
  })])], 1) : _vm._e()], _c('div', {
    staticClass: "overflow-x-hidden mb-3"
  }, [_c('b-card', {
    staticClass: "border border-1 reward-card",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "\n            reward-card__header\n            px-3\n            d-flex\n            justify-content-between\n            align-items-center\n          "
  }, [_c('div', {
    staticClass: "reward-card__title"
  }, [_vm._v(_vm._s(_vm.card.name))]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "reward-card__header__point"
  }, [_vm._v(_vm._s(_vm.card.point))]), _c('span', {
    staticClass: "small ml-2"
  }, [_vm._v("點")])])]), _c('div', {
    staticClass: "reward-card__body p-4"
  }, _vm._l(_vm.card.threshold, function (i) {
    return _c('div', {
      key: i,
      staticClass: "reward-card__body__point",
      class: i <= _vm.card.point ? 'active' : ''
    }, [_c('div', {
      staticClass: "\n                reward-card__body__point__stamp\n                d-flex\n                justify-content-center\n                align-items-center\n              "
    }, [i <= _vm.card.point ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": require("./images/stamp.svg")
      }
    }) : _c('span', [_vm._v(_vm._s(i))])])]);
  }), 0)])], 1), _c('div', {
    staticClass: "reward-card-list"
  }, [_c('div', {
    staticClass: "reward-card-list__item"
  }, [_c('div', [_c('div', {
    staticClass: "reward-card-list__image"
  }, [_c('img', {
    attrs: {
      "src": _vm.card.img_url
    }
  })]), _c('div', {
    staticClass: "reward-card-list__stamp"
  }, _vm._l(_vm.card.threshold, function (i) {
    return _c('i', {
      key: i,
      staticClass: "fa fa-star",
      class: _vm.card.point >= i && 'active',
      attrs: {
        "aria-hidden": "true"
      }
    });
  }), 0)]), _c('div', {
    staticClass: "reward-card-list__content"
  }, [_c('div', {
    staticClass: "reward-card-list__title"
  }, [_vm._v(_vm._s(_vm.card.name))]), _c('div', {
    staticClass: "reward-card-list__desc"
  }, [_vm._v(_vm._s(_vm.card.content))]), _c('div', {
    staticClass: "reward-card-list__date"
  }, [_vm._v(" 開始日期" + _vm._s(_vm.formatDate(_vm.card.start_date)) + " ")]), _c('div', {
    staticClass: "reward-card-list__date"
  }, [_vm._v(" 到期日期" + _vm._s(_vm.formatDate(_vm.card.end_date)) + " ")])])])]), _vm.card.status === 9 && _vm.card.point == _vm.card.threshold ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffProjAbbottAndRewardsCardRedeem'
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig('reward_card_apply_button_text')) + " ")]) : _vm._e(), _c('div', {
    staticClass: "reward-award mt-3"
  }, [_c('div', {
    staticClass: "reward-award__title"
  }, [_vm._v("點數獎項")]), _vm._l(_vm.awards, function (i) {
    return _c('b-card', {
      key: i.id,
      staticClass: "reward-award-item d-flex flex-nowrap flex-row mt-3",
      attrs: {
        "no-body": ""
      }
    }, [_c('div', {
      staticClass: "reward-award-item__image"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": i.img_url
      }
    })]), _c('div', {
      staticClass: "flex-fill p-2 d-flex flex-column"
    }, [_c('div', {
      staticClass: "reward-award-item__title flex-fill"
    }, [_vm._v(_vm._s(i.name))])])]);
  })], 2)], 2), _vm.card.precautions ? _c('div', {
    staticClass: "reward-notice s-p-3"
  }, [_c('div', {
    staticClass: "reward-notice__title"
  }, [_vm._v("注意事項")]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.card.precautions)
    }
  })]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }